export default __webpack_public_path__ + "static/media/smoke 1.3f703fa9.svg";